module.exports = __webpack_public_path__ + "img/image1.43fbff92.png";